import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { createContainer } from 'unstated-next'

export function navigateTo(path: string) {
    if (globalNavigate)
        globalNavigate(path)
}

export function navigateToThenBack(path: string) {
    if (globalNavigate) {
        const currentPath = window.location.pathname
        if (!currentPath.includes(path)) {
            globalNavigate(path, { state: { shouldNavigateBack: true } })
        }
    }
}

export function navigateBack() {
    if (globalNavigate)
        globalNavigate(-1)
}

let globalNavigate: ReturnType<typeof useNavigate> | null = null

function setGlobalNavigate(navigate: ReturnType<typeof useNavigate>) {
    globalNavigate = navigate
}

export function useNavigationInitializer() {
    const navigate = useNavigate()

    useEffect(() => {
        setGlobalNavigate(navigate)
    }, [navigate])
}

function useNavigationTracker() {
    const [currentPath, setCurrentPath] = useState(window.location.pathname + window.location.search)

    useEffect(() => {
        const handleLocationChange = () => {
            const newPath = window.location.pathname + window.location.search
            if (currentPath !== newPath)
                setCurrentPath(newPath)
        }

        window.addEventListener('popstate', handleLocationChange)

        const originalPushState = history.pushState
        const originalReplaceState = history.replaceState

        history.pushState = function (...args) {
            originalPushState.apply(history, args)
            handleLocationChange()
        }

        history.replaceState = function (...args) {
            originalReplaceState.apply(history, args)
            handleLocationChange()
        }

        return () => {
            window.removeEventListener('popstate', handleLocationChange)
            history.pushState = originalPushState
            history.replaceState = originalReplaceState
        }
    }, [currentPath])

    return {
        currentPath
    }
}

export const NavigationTrackerContainer = createContainer(useNavigationTracker)